<template>
  <div class="content" :style="{ backgroundColor: bgColor }" @touchmove.prevent>
    <Header :title="title" :bgColor="bgColor" @toBack="toBack"></Header>
    <!-- 手机号登录流程 -->
    <div class="step1" v-if="step == 1">
      <div class="topInfo">
        请输入发送至
        <span>{{
          pcode + phone.slice(0, 3) + '******' + phone.slice(9, 11)
        }}</span>
        的 6 位验证码，有效期 3 分钟
      </div>
      <VerificationCode
        ref="ver"
        :isError="isError"
        :codeValue="ucode"
        @updateValue="getValue"
      >
      </VerificationCode>
      <div class="timeBox">
        <div>
          <span v-if="time === 60" @click="againGetCode(0)"
            >重新获取验证码</span
          >
          <span v-if="time < 60">{{ time }}s后重新获取</span>
        </div>
        <span v-if="time === 60 && updateGet" @click="againGetCode(2)"
          >未收到验证码？</span
        >
      </div>
      <div class="btBox">
        <fm-button
          class="loginBt"
          type="primary"
          :disabled="btnOne"
          round
          size="medium"
          @click="checkPhoneCode"
          >确定</fm-button
        >
      </div>
    </div>
    <!-- 设置账号/密码 -->
    <div class="step2" v-if="step == 2">
      <div class="font1">设置账号</div>
      <FmInput
        v-model="username"
        class="loginInput"
        placeholder="请设置Feemoo账号（6-20位数字或字母）"
        clearable
      ></FmInput>
      <div class="font2">设置密码</div>
      <FmInput
        style="margin-bottom: 12px"
        v-model="password"
        class="loginInput"
        placeholder="请设置登录密码（至少6位数字或字母）"
        type="password"
        clearable
      ></FmInput>
      <FmInput
        v-model="passwordAgain"
        class="loginInput"
        placeholder="请再次输入密码"
        type="password"
        clearable
      ></FmInput>
      <div class="font2" v-if="zone_switch == 1">选择区服</div>
      <el-select
        class="loginSelect"
        placeholder="请选择区服"
        v-model="zone_id"
        v-if="zone_switch == 1"
      >
        <el-option
          v-for="item in zone_config"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        >
        </el-option>
      </el-select>
      <span class="font3" v-if="zone_switch == 1"
        >我们将遵照账号区服当地法律提供服务，一旦确定不可更改</span
      >
      <fm-button
        class="loginBt"
        type="primary"
        :disabled="btnTwo"
        round
        :loading="loading"
        size="medium"
        @click="nextApi()"
        >确定</fm-button
      >
    </div>
    <SafeDialog @onConfirm="onConfirm" ref="MyDialog" />
    <BrowserRestrict ref="BrowserRestrictRef"></BrowserRestrict>
  </div>
</template>

<script>
import {
  loginAPI,
  LoginSSOAPI,
  limitationDelAPI,
  checkPhone,
  phoneLoginCodeAPI,
  registerAPI,
  getZoneIdConfigAPI,
} from '@/axios/login'
import Header from '@/components/NavTopLogin/index.vue'
import SafeDialog from '@/components/Dialog/SafeDialog.vue'
import BrowserRestrict from '@/components/Dialog/BrowserRestrict'
import VerificationCode from '@/components/VerificationCode/index.vue'
export default {
  components: {
    Header,
    SafeDialog,
    BrowserRestrict,
    VerificationCode,
  },
  name: 'phone',
  data() {
    return {
      step: 1,
      ucode: '', //验证码字段
      time: 60,
      timerA: '',
      updateGet: false,
      sms_type: 0,
      msgid: '',
      title: '验证手机号',
      bgColor: 'transparent',
      pcode: '+86',
      phone: '',
      isError: false,
      password: '',
      username: '',
      passwordAgain: '',
      loading: false,
      zone_id: '', //区服ID
      zone_switch: 0, //区服开关
      zone_config: [], //区服list
    }
  },
  watch: {
    deviceClass() {
      if (this.deviceClass == 'pc') {
        window.location.replace(`${this.$glb.feemooUrl}/login?path=drive`)
      }
    },
    ucode() {
      if (this.ucode.length < 6) {
        this.isError = false
      }
    },
  },
  created() {
    if (this.deviceClass == 'pc') {
      window.location.replace(`${this.$glb.feemooUrl}/login?path=drive`)
    }
    let arr = this.$store.state.phoneInfo
    if (arr && arr.msgid) {
      this.msgid = arr.msgid
      this.pcode = arr.pcode
      this.phone = arr.phone
      if (this.time === 60) {
        this.timerA = setInterval(() => {
          this.minute()
        }, 1000)
      }
    } else {
      this.$router.push({ path: '/login' })
    }
  },
  mounted() {
    this.getZoneIdConfig()
  },
  computed: {
    deviceClass() {
      return this.$store.getters['device/deviceClass']
    },
    btnOne() {
      if (this.ucode.length == 6) {
        return false
      }
      return true
    },
    btnTwo() {
      if (
        this.username.trim().length >= 6 &&
        this.password.trim().length >= 6 &&
        this.passwordAgain.trim().length >= 6
      ) {
        return false
      }
      return true
    },
  },
  methods: {
    getZoneIdConfig() {
      getZoneIdConfigAPI()
        .then(res => {
          if (res.status == 1) {
            this.zone_switch = res.data.zone_switch
            this.zone_config = res.data.zone_config
            const selectedZone = this.zone_config.find(
              item => item.is_select == 1
            )
            // 如果找到则赋值id，否则可以设置默认值或处理未找到的情况
            this.zone_id = selectedZone ? selectedZone.id : '' // 或其他默认值
          }
        })
        .catch(err => {})
    },
    againGetCode(row) {
      this.sms_type = row
      //发送手机验证码
      this.sendCodeNew()
    },
    //验证码输入回调
    getValue(newValue) {
      this.ucode = newValue
      if (this.ucode.length == 6) {
        this.checkPhoneCode()
      }
    },
    minute: function () {
      this.time = this.time - 1
      if (this.time == 0) {
        this.time = 60
        this.updateGet = true
        clearInterval(this.timerA)
      }
    },
    //清除输入验证码数据
    clearOp() {
      this.time = 60
      this.timerA && clearInterval(this.timerA)
    },
    sendCodeNew(captcha_verify, validate = {}) {
      return new Promise(resolve => {
        if (validate == 'close') {
          return
        }
        this.clearOp()
        phoneLoginCodeAPI({
          lot_number: validate?.lot_number || '',
          captcha_output: validate?.captcha_output || '',
          pass_token: validate?.pass_token || '',
          gen_time: validate?.gen_time || '',
          pcode: this.pcode,
          phone: this.phone,
          code_type: 0, //验证码类型：0-短信登录注册 1-短信找回密码 2-修改手机号
          captcha_verify: captcha_verify || '',
          sms_type: this.sms_type,
        })
          .then(res => {
            if (res.status == 1) {
              resolve({
                result: true,
                validate: true,
              })
              this.$htoast(res.msg)
              this.msgid = res.data.msgid
              if (this.time === 60) {
                this.timerA = setInterval(() => {
                  this.minute()
                }, 1000)
              }
              this.ucode = ''
              this.$nextTick(() => {
                this.$refs.ver?.reset()
              })
            } else if (res.status == 90001) {
              resolve({
                result: false,
                validate: false,
              })
              this.$htoast(res.msg)
              this.$AliCode.handleOpen(this.sendCodeNew)
            } else if (res.status == 90002) {
              this.$utils.initgt4(
                '5b0562a75492b420626b745b229e83a4',
                this.sendCodeNew
              )
            } else {
              resolve({
                result: true,
                validate: true,
              })
              this.$htoast(res.msg)
            }
          })
          .catch(err => {})
      })
    },
    checkPhoneCode: _.debounce(
      function () {
        if (this.btnOne) {
          return
        }
        let data = {
          pcode: this.pcode,
          phone: this.phone,
          msgid: this.msgid,
          ucode: this.ucode,
        }
        checkPhone(data).then(res => {
          if (res.status == 1) {
            this.username = ''
            this.password = ''
            this.passwordAgain = ''
            const selectedZone = this.zone_config.find(
              item => item.is_select == 1
            )
            // 如果找到则赋值id，否则可以设置默认值或处理未找到的情况
            this.zone_id = selectedZone ? selectedZone.id : '' // 或其他默认值
            this.step = 2
            this.title = '设置账号/密码'
          } else if (res.status == 1014) {
            //已经注册过的手机号走注册
            this.nextApi('have')
          } else {
            this.isError = true
            this.$htoast(res.msg)
          }
        })
      },
      500,
      {
        leading: true, //指定在延迟开始前调用
        trailing: false, //指定在延迟结束后调用
      }
    ),
    nextApi: _.debounce(
      function (row) {
        if ((!row && this.btnTwo) || this.loading) {
          return
        }
        let zhLength = this.username.trim().length
        if ((zhLength < 6 || zhLength > 20) && !row) {
          this.$htoast('Feemoo账号仅支持6-20位数字或字母，请修改')
          return
        }
        if (this.password !== this.passwordAgain && !row) {
          this.$htoast('密码不一致，请重试')
          return
        }
        this.loading = true
        let fshort = sessionStorage.getItem('shortFshort') || ''
        let data = {
          pcode: this.pcode,
          phone: this.phone,
          msgid: this.msgid,
          ucode: this.ucode,
          username: this.username,
          password: this.password,
          rcode: fshort,
          zone_id: this.zone_id,
        }
        registerAPI(data)
          .then(res => {
            let status = Number(res.status)
            if (status === 1011) {
              if (res.data.type == 1) {
                this.showLimitLogin(res.data)
              } else {
                this.showBrowserRestrict(res.data)
              }
              this.loading = false
              return
            }
            if (res.status == 1) {
              this.loginFetch(res.data.sso[0]?.token)
              setTimeout(() => {
                this.toComplete()
              }, 600)
            } else if (res.status == 2) {
              this.step = 2
              this.loading = false
            } else {
              if (res.msg === '请进行重新验证') {
                this.step = 1
              }
              this.loading = false
              this.$htoast(res.msg)
            }
          })
          .catch(err => {
            this.loading = false
          })
      },
      500,
      {
        leading: true, //指定在延迟开始前调用
        trailing: false, //指定在延迟结束后调用
      }
    ),
    toBack() {
      if (this.step == 1) {
        this.$router.replace({ path: '/login' })
      } else {
        this.title = '验证手机号'
        this.bgColor = 'transparent'
        this.step = 1
      }
    },
    loginFetch(token) {
      LoginSSOAPI({ token }).then(res => {
        if (res.status == 1) {
          localStorage.setItem('shortToken', res.data.authtoken)
        }
      })
    },
    showLimitLogin(data) {
      this.loginTip.pre = data.last_province
      this.loginTip.now = data.current_province
      this.loginTip.access_token = data.access_token
      this.$refs.MyDialog.show(data)
    },
    onConfirm: _.debounce(
      function () {
        this.$refs.MyDialog.close()
        limitationDelAPI({
          access_token: this.loginTip.access_token,
        })
          .then(res => {
            if (res.status == 1) {
              this.loginFetch(res.data.sso[0]?.token)
              setTimeout(() => {
                this.toComplete()
              }, 600)
            } else {
              this.$htoast(res.msg)
            }
          })
          .catch(err => {})
      },
      500,
      {
        leading: true, //指定在延迟开始前调用
        trailing: false, //指定在延迟结束后调用
      }
    ),
    showBrowserRestrict: _.debounce(
      function (data) {
        this.$refs.BrowserRestrictRef.handleOpen(data)
      },
      50,
      {
        leading: true, //指定在延迟开始前调用
        trailing: false, //指定在延迟结束后调用
      }
    ),
    goNextBrowser(data) {
      //弃用了 现在删除完常用登录地点后 不会自动登录 还需要用户手动点击
      return
      if (data != '') {
        this.loginFetch(data.sso[0]?.token)
      }
      setTimeout(() => {
        this.toComplete()
      }, 600)
    },
    toComplete() {
      let fshort = sessionStorage.getItem('shortFshort')
      this.loading = false
      if (fshort) {
        this.$router.replace({ path: '/d/' + fshort })
      } else {
        this.$router.replace({ path: '/' })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.content {
  display: flex;
  flex-direction: column;
  background: #f3f5f7;
  overflow: auto;
  height: 100%;
  overflow-x: hidden;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
  &::-webkit-scrollbar-thumb {
    display: none;
  }
  &::-webkit-scrollbar-track {
    display: none;
  }
  .step1 {
    height: 100%;
    padding: 40px 16px 0 16px;
    .topInfo {
      font-weight: 400;
      font-size: 14px;
      color: #8a8b92;
      line-height: 20px;
      text-align: left;
      margin-bottom: 32px;
      width: 100%;
      span {
        color: #2c2c2c !important;
      }
    }
    .timeBox {
      margin-top: 24px;
      font-weight: 400;
      font-size: 14px;
      color: #f67942;
      line-height: 20px;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .btBox {
      margin-top: 32px;
      padding: 0 18px;
      .loginBt {
        width: 100%;
        height: 48px;
        border-radius: 48px;
        span {
          font-weight: 500;
          font-size: 14px;
          color: #ffffff;
          line-height: 20px;
        }
      }
    }
  }
  .step2 {
    height: 100%;
    padding: 40px 34px 0 34px;
    display: flex;
    flex-direction: column;
    .font1 {
      font-weight: 400;
      font-size: 14px;
      color: #2c2c2c;
      line-height: 20px;
      margin-bottom: 12px;
    }
    .font2 {
      font-weight: 400;
      font-size: 14px;
      color: #2c2c2c;
      line-height: 20px;
      margin-bottom: 12px;
      margin-top: 36px;
    }
    .font3 {
      font-weight: 400;
      font-size: 11px;
      color: #bdbdbe;
      line-height: 16px;
      margin-top: 4px;
      margin-left: 6px;
    }
    .loginBt {
      width: 100%;
      height: 48px;
      border-radius: 48px;
      margin-top: 24px;
      span {
        font-weight: 500;
        font-size: 14px;
        color: #ffffff;
        line-height: 20px;
      }
    }
  }
}
</style>
